import React from 'react';
import { useTranslation } from 'react-i18next';
import './Socials.css';

const SOCIALS = [
  {
    key: "socials.instagram",
    href: "https://www.instagram.com/himanshuchitoria/",
    svg: (
      <svg viewBox="0 0 448 512" className="svg" width={28} height={28} aria-label="Instagram">
        <path fill="currentColor" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9 0 63.6 51.3 114.9 114.9 114.9 63.6 0 114.9-51.3 114.9-114.9 0-63.6-51.3-114.9-114.9-114.9zm0 186c-39.5 0-71.6-32.1-71.6-71.6 0-39.5 32.1-71.6 71.6-71.6 39.5 0 71.6 32.1 71.6 71.6 0 39.5-32.1 71.6-71.6 71.6zm146.4-194.3c0 14.9-12 27-27 27-14.9 0-27-12.1-27-27s12.1-27 27-27c15 0 27 12.1 27 27zm76.1 27.2c-1.7-35.3-9.9-66.7-36.2-92.9S388.6 8.3 353.3 6.6C320.7 4.9 127.2 4.9 94.7 6.6 59.4 8.3 28 16.5 1.7 42.9S8.3 123.4 10 158.7c1.7 35.3 1.7 228.9 0 264.2-1.7 35.3-9.9 66.7-36.3 92.9S59.4 503.7 94.7 505.4c32.5 1.7 226 1.7 258.6 0 35.3-1.7 66.7-9.9 92.9-36.3 27.2-27.2 35.4-58.6 37.1-93.9 1.7-35.3 1.7-228.9 0-264.2zM398.8 424c-7.8 19.5-22.8 34.5-42.4 42.4-29.2 11.6-98.1 9-132.4 9s-103.2 2.6-132.4-9c-19.5-7.8-34.5-22.8-42.4-42.4-11.6-29.2-9-98.1-9-132.4s-2.6-103.2 9-132.4c7.8-19.5 22.8-34.5 42.4-42.4 29.2-11.6 98.1-9 132.4-9s103.2-2.6 132.4 9c19.5 7.8 34.5 22.8 42.4 42.4 11.6 29.2 9 98.1 9 132.4s2.6 103.2-9 132.4z"/>
      </svg>
    )
  },
  {
    key: "socials.discord",
    href: "https://discord.com/",
    svg: (
      <svg viewBox="0 0 640 512" className="svg" width={28} height={28} aria-label="Discord">
        <path fill="currentColor" d="M524.5 69.8a1.5 1.5 0 0 0-.8-.7A485 485 0 0 0 404.1 32a1.8 1.8 0 0 0-1.9.9c-4.1 7.1-8.6 16.2-12 23.5a447.8 447.8 0 0 0-134.4 0c-3.5-7.4-7.9-16.4-12-23.5a1.9 1.9 0 0 0-1.9-.9A483.8 483.8 0 0 0 116 69.1a1.7 1.7 0 0 0-.8.7C39.1 183.7 18.2 294.7 28.4 404.4a2 2 0 0 0 .8 1.4 487.7 487.7 0 0 0 146.8 74.2 1.9 1.9 0 0 0 2.1-.7c11.9-16.3 22.6-33.5 32-51.7a1.9 1.9 0 0 0-1-2.6 322.9 322.9 0 0 1-45.9-21.8 1.9 1.9 0 0 1-.2-3.1c3.1-2.3 6.2-4.7 9.1-7.1a1.8 1.8 0 0 1 1.9-.3c96.2 43.9 200.4 43.9 295.5 0a1.8 1.8 0 0 1 1.9.2c2.9 2.4 6 4.9 9.1 7.2a1.9 1.9 0 0 1-.2 3.1 301.4 301.4 0 0 1-45.9 21.8 1.9 1.9 0 0 0-1 2.6c9.4 18.3 20.1 35.4 32 51.7a1.9 1.9 0 0 0 2.1.7 487.8 487.8 0 0 0 146.8-74.2 2 2 0 0 0 .8-1.4c10.2-109.7-10.8-220.7-87.2-334.6zM222.5 337.6c-29 0-52.8-26.6-52.8-59.2s23.7-59.2 52.8-59.2 52.8 26.8 52.8 59.2-23.7 59.2-52.8 59.2zm195.4 0c-29 0-52.8-26.6-52.8-59.2s23.7-59.2 52.8-59.2 52.8 26.8 52.8 59.2-23.8 59.2-52.8 59.2z"/>
      </svg>
    )
  },
  {
    key: "socials.twitter",
    href: "https://twitter.com/",
    svg: (
      <svg viewBox="0 0 512 512" className="svg" width={28} height={28} aria-label="Twitter">
        <path fill="currentColor" d="M459.4 151.7c.3 4.6.3 9.1.3 13.6 0 138.7-105.6 298.6-298.6 298.6-59.4 0-114.7-17.2-161.1-47.1 8.5.9 16.6 1.3 25.3 1.3 49 0 94.2-16.6 130.3-44.8-46.1-1-84.8-31.2-98.1-72.8 6.5 1 13 1.6 19.8 1.6 9.4 0 18.8-1.3 27.6-3.6-48.1-9.8-84.1-51.9-84.1-103v-1.3c13.9 7.8 30.2 12.7 47.4 13.3-28.2-18.8-46.8-51-46.8-87.4 0-19.5 5.2-37.4 14.3-53 51.7 63.7 129.3 105.3 216.4 109.8-1.6-7.8-2.6-15.9-2.6-24 0-57.8 46.8-104.9 104.9-104.9 30.2 0 57.5 12.7 76.7 33.1 23.7-4.5 46.5-13.3 66.6-25.3-7.8 24.4-24.4 44.8-46.1 57.8 21.1-2.3 41.6-8.1 60.4-16.2-14.3 20.8-32.2 39.3-52.6 54.3z"/>
      </svg>
    )
  },
];

const SocialsCard: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="card">
      <div className="background"></div>
      <div className="logo">{t('socials.title')}</div>
      {SOCIALS.map((item, i) => (
        <a
          key={item.key}
          href={item.href}
          target="_blank"
          rel="noopener noreferrer"
          className={`box box${i + 1}`}
          aria-label={t(`socials.${item.key}.ariaLabel`)}
        >
          <span className="icon">{item.svg}</span>
        </a>
      ))}
      <div className="box box4"></div>
    </div>
  );
};

export default SocialsCard;
